export default __webpack_public_path__ + "static/media/sell3.0e2e5c73.png";